import { ChangeEvent, forwardRef, Ref, useCallback, useMemo } from "react";
import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material'
import { useFormikContext } from "formik";
import { debounce } from "lodash";
import { hEncode } from "@/utils/hashid";

export type TextFieldProps = MuiTextFieldProps & {
  label: string;
  name: string;
  ref: Ref<any>;
}

const TextField = forwardRef<any, TextFieldProps>((props, ref) => {
  const {
    label,
    name,
    ...rest
  } = props
  const {
    touched,
    errors,
    values,
    handleBlur,
    handleChange: formikOnChange,
  } = useFormikContext<any>()

  const autoTrim = useMemo(() => {
    return debounce((s:string) => {
      const trimed = s && typeof(s) === 'string' ? s.trim() : s
      formikOnChange({target:{value:trimed, name}})
    }, 1500)
  }, [formikOnChange, name])

  const handleChange = useCallback((e: ChangeEvent<any>) => {
    formikOnChange(e)
    autoTrim(e.target.value)
  }, [formikOnChange, autoTrim])

  const uid = useMemo(() => name + '-' + hEncode(new Date().getMilliseconds()), [name])

  return (
    <MuiTextField
      id={uid}
      error={Boolean(touched[name] && errors[name])} 
      fullWidth
      helperText={touched[name] && errors[name]}
      label={label}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      value={values[name]}
      variant="outlined"
      inputRef={ref}
      {...rest}
    />
  )
})

export default TextField;
